import React, {Component} from 'react';

import './radioSlider.css';


class RadioSlider extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`radio-slider-base-container ${this.props.fullWidth ? 'radio-slider-full-width' : ''}`}>
                {this.props.description && <div className='radio-slider-description'>{this.props.description}</div>}
                <div
                    className={`radio-slider-container ${this.props.customClass} ${this.props.fullWidth ? 'radio-slider-full-width' : ''}`}>
                    {
                        this.props.buttons.map(button => {
                            let buttonClass = ['button']
                            if (button.value === this.props.value) buttonClass.push('active')
                            if (button.disabled === true) buttonClass.push('disabled')

                            return <div key={button.value} className={buttonClass.join(' ')}
                                        onClick={() => this.props.setValue && (button.disabled === false || button.disabled === undefined) ? this.props.setValue(button.value) : null}>
                                {button.name}
                            </div>
                        })
                    }
                </div>
            </div>
        );
    }
}


export default RadioSlider;